export function formatUAH(value: number): string {
  return `${Math.round(value).toLocaleString("uk-UA")} грн`;
}

export function formatUAHPerMonth(value: number): string {
  return `${Math.round(value).toLocaleString("uk-UA")} грн/міс.`;
}
